import { createRoot } from 'react-dom/client';
import './index.css';
import '@formatjs/intl-datetimeformat/polyfill';
import '@formatjs/intl-datetimeformat/locale-data/fr';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/fr';
import { listenAxeptioCookies } from './services/googleAnalytics/init';
import { ApolloLoader } from './graphql/ApolloLoader';
import moment from 'moment';
import 'moment/locale/fr';
import Providers from './Providers';
import OfflinePage from 'pages/OfflinePage';

moment.locale('fr');

listenAxeptioCookies();

//unregister sw
navigator.serviceWorker.getRegistrations().then((registrations) => {
  for (const registration of registrations) {
      registration.unregister();
  } 
});

const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

const container = document.getElementById('root');
const root = createRoot(container);

window.addEventListener('offline', () =>
  root.render(
    <Providers>
      <OfflinePage />
    </Providers>
  ),
);

window.addEventListener('online', () => window.location.reload());

root.render(
  <Providers>
    <ApolloLoader />
  </Providers>
);